import React from "react";
import { Reveal, SectionHeader } from "@/components/ui-blocks/Reveal";
import { IssueReportForm } from "@/components/forms/IssueReportForm";
import { AlertTriangle, LockKeyhole, Timer } from "lucide-react";

export const ReportIssueSection = () => (
  <section id="report-issue" className="surface-tint">
    <div className="container-wide py-16 lg:py-24">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <SectionHeader eyebrow="Report a Community Issue" title="See something that needs fixing? Report it." lead="Sanitation, infrastructure, safety, environment — CAF partners with local authorities to escalate valid reports." />
          <div className="grid gap-3">
            {[[Timer, "Acknowledged within 48 hours"], [LockKeyhole, "Reports are confidential by default"], [AlertTriangle, "Please avoid personal identifiers of victims"]].map(([Icon, t]) => (
              <div key={t} className="flex items-start gap-3 rounded-lg border border-[hsl(var(--border))] bg-card p-4">
                <div className="h-9 w-9 rounded-md bg-[hsl(var(--orange)/0.12)] text-[hsl(var(--orange))] grid place-items-center"><Icon className="h-4.5 w-4.5" /></div>
                <div className="text-sm text-[hsl(var(--muted-ink))]"><span className="font-semibold text-[hsl(var(--navy))] block">{t}</span></div>
              </div>
            ))}
          </div>
        </div>
        <div className="lg:col-span-7">
          <Reveal><div className="rounded-xl border border-[hsl(var(--border))] bg-card p-6"><IssueReportForm /></div></Reveal>
        </div>
      </div>
    </div>
  </section>
);
